module.exports = __webpack_public_path__ + "static/media/master_im_4.b3dfb6f3.jpg";